import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addupselling',
  template: require('./addupselling.component.html'),
  styles: [],
})
export class AddaddupsellingComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }


}
